// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"52": "3cf6e779","909": "056f5a31","910": "d75ee1ea",}[chunkId] + ".js"
}